import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Api } from "../../../redux/api/BaseApi";
import { TicketApi } from "../../../redux/api/TicketApi";
import { toDigital } from "../../../utils/utils";
import { FileApi } from '../../../redux/api/FileApi';
import { FileType } from '../../../types/File/FileType';
import { SimpleSpinny } from "../../Nav/Spinny";
import { useReduxSelector } from "../../../redux/hooks";
import { IAction } from "../../../types/Action/IAction";
import React, { useEffect } from "react";
import { useCurrentUserContext } from "../../../context/UserContext";

const SplitActions: React.FC = (props) => {
    const { data: isFileActive } = FileApi.useIsActiveQuery(FileType.Call_Action_Internal)
    const { profile: userProfile } = useCurrentUserContext();
    const splitOptions = useReduxSelector(state => state.newTicket.splitFromTicketOptions)
    const [getSplitActions, { isLoading }] = TicketApi.useActionsByIdMutation();
    const [actions, setActions] = React.useState<IAction[]>([])

    useEffect(() => {
        if (splitOptions && splitOptions.Ids.length > 0 && splitOptions.TicketId > 0)
            getSplitActions(splitOptions).unwrap().then((r) => {
                setActions(r.map(a => { return { ...a, Bill_Time: toDigital(a.Billable_Time), Non_Bill_Time: toDigital(a.Non_Billable_Time) } }));
            }).catch((err) => { });

    }, [splitOptions, getSplitActions])

    return (<>
        <p className="k-form-hint p-3">These {userProfile?.Phrases.Action}s will be Split (moved) to this {userProfile?.Phrases.CallPhrase} when logged.</p>
        {isLoading
            ? <SimpleSpinny />
            : <Grid data={actions} sort={[{ field: "Action_Id" }]}>
                <GridColumn field="Staff_Name" title="Author" width={110} />
                <GridColumn field="Action_Dt" title="Timestamp" width={90} cells={{
                    data: (c) => {
                        return <td><div className="whitespace-pre-wrap">{new Date(c.dataItem.Action_Dt + 'Z').toLocaleDateString()}<br />
                            {new Date(c.dataItem.Action_Dt + 'Z').toLocaleTimeString()}</div></td>
                    }
                }} />
                <GridColumn field="Action_Notes" title="Notes" width={undefined} cells={{
                    data: (c) => {
                        return <td><div className="whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: c.dataItem.HTML_Notes || c.dataItem.Action_Notes }}></div></td>
                    }
                }} />
                {/* Attachment column */}
                {isFileActive && <GridColumn field="File_Count" title="" width={40} headerClassName="template-attach-column" headerCell={(c) => {
                    return <span className="k-font-icon k-i-attachment p-1"></span>
                }} />}
                <GridColumn field="Bill_Time" title={userProfile?.Features?.Non_Bill_Time ? "Bill" : "Time"}
                    width={80} />
                {userProfile?.Features?.Non_Bill_Time && <GridColumn field="Non_Bill_Time" width={80} title='Non Bill' />}

            </Grid>}
    </>)
}

export default SplitActions;